import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {MessageService, PrimeNGConfig} from 'primeng/api';
import {ContactService, GenericOption, UserCoreService, UserProfileProperty} from '@cas-hub/acabim-common-client';
import {ContactTypeService} from '../../../_services/contact-type-service';
import {ContactOrganisationsService} from '../../../_services/contact-organisations-service';
import {FormArray, FormControl, FormGroup, Validators} from '@angular/forms';
import {Observable, Subscription} from 'rxjs';
import {ContactMethods, ContactNames, ContactParcel, ContactRoleType, ContactSimple} from '../../../_models/contact-details.model';
import {ContactSetterService} from '../../../_services/contact-setter.service';
import {GenericPair} from '../../../_models/generic.model';
import {Contact} from '@cas-hub/acabim-common-client/lib/_models/user.model';

@Component({
  selector: 'acabim-admin-add-contact',
  templateUrl: './add-contact.component.html',
  styleUrls: ['./add-contact.component.scss'],
  providers: [MessageService]
})
export class AddContactComponent implements OnInit, OnDestroy {
  @Input() set loadContact(contactId: number) {
    if(contactId) {
      this.isLoading = true;
      this.existingContactId = contactId.toString();
      this.contactService.getContact(contactId, true).subscribe(c => {
        console.dir(c);
        this.isLoading = false;
        if(c) {
          this.existingContact = c;
          this.success = {
            present: 'Updating',
            past: 'updated'
          };
          this.userName = c.user_name;
          if(c.is_organisation === 1) {
            this.isOrganisation = true;
          }
          this.initServices();
        }
      });
    }
  }
  @Output() submit = new EventEmitter<boolean>();
  private contactOrgSub: Subscription = new Subscription();
  private contactTypeSub: Subscription = new Subscription();

  addContactForm: FormGroup | null = null;
  addPrimaryContact = false;
  allOrganisations: { label: string, value: string }[] = [{label: 'None', value: '0'}];
  contactDetailsForm: FormGroup | null = null;
  contactInvitation = false;
  contactNames: ContactNames = {first_name: '', last_name: '', name: '', legal_name: ''};
  contactOrganisationPropertiesForm: FormGroup | null = null;
  contactTypes: { label: string, value: string }[] = [];
  displayAddEmailModal = false;
  displayAddPhoneModal = false;
  emails: ContactMethods[] = [];
  editEmail: ContactMethods | null = null;
  editPhone: ContactMethods | null = null;
  existingContact: Contact | null = null;
  existingContactId: string | null = null;
  gatheredData: ContactParcel | null = null;
  inviteContact = false;
  invitePrimaryContact = false;
  isLoading = false;
  isOrganisation = false;
  members: GenericPair[] = [];
  organisationAttributes: string[] = ['Fire warden', 'Medic', 'Union representative'];
  organisationAttributesInput: any[] = [];
  organisationContactForm: FormGroup | null = null;
  organisationContacts: ContactSimple[] = [];
  organisationDetailsForm: FormGroup | null = null;
  organisationName = '';
  organisationProperties: string[] = ['Access card ID'];
  organisationPropertiesInput: any[] = [];
  phones: ContactMethods[] = [];
  previousStepNumbers: number[] = [];
  processing = false;
  roleOptions: GenericOption[] = [];
  selectedMember = false;
  selectedNewMember = false;
  stepNumber = 1;
  stepOneForm: FormGroup | null = null;
  stepThreeForm: FormGroup | null = null;
  success = {
    present: 'Adding',
    past: 'added'
  };

  userDetailsForm: FormGroup | null = null;
  user_id = '';
  userName = '';

  stepTitlesEdit = {
    step1: 'Edit basic details',
    step2: 'Edit organisation details',
    step3: 'Edit organisation contacts',
    step5: 'Edit profile properties',
    step6: 'Edit additional properties',
  };
  stepTitles = {
    step1: 'Let\'s get started …',
    step2: 'Organisation details',
    step3: 'Add a contact to the organisation',
    step5: 'Add some profile properties',
    step6: 'Additional properties',
  };

  constructor(
      private readonly contactService: ContactService,
      private readonly contactOrganisationsService: ContactOrganisationsService,
      private readonly contactSetterService: ContactSetterService,
      private readonly contactTypeService: ContactTypeService,
      private readonly messageService: MessageService,
      private readonly primengConfig: PrimeNGConfig,
      private readonly userCoreService: UserCoreService,
  ) {}

  ngOnInit(): void {
    this.primengConfig.ripple = true;
    this.previousStepNumbers.push(1);
    this.editEmail = null;
    this.editPhone = null;
    this.initServices();
   }

  ngOnDestroy(): void {
    this.contactTypeSub.unsubscribe();
    this.contactOrgSub.unsubscribe();
  }

  initForms(): void {
    this.roleOptions = []
    const crt = Object.values(ContactRoleType);
    crt.map(cr => {
      if (typeof cr !== 'number') {
        this.roleOptions.push({
          label: cr,
          value: cr
        });
      }
    });
    this.stepOneForm = new FormGroup({
      contactType: new FormControl(null, Validators.required),
      roleType: new FormControl(ContactRoleType.External.toString(), Validators.required),
      isLegalRep: new FormControl(null),
      selectInvite: new FormControl(null),
      isEntity: new FormControl(0),
      memberOf: new FormControl(0),
      emailInvite: new FormControl('', [Validators.required, Validators.email])
    });
    this.organisationDetailsForm = new FormGroup({
      organisationName: new FormControl(null, Validators.required),
      legalName: new FormControl(null),
      addPrimaryContact: new FormControl(0),
      memberOfExisting: new FormControl(null),
      memberOfExistingA: new FormControl(null),
      primaryContactFirstName: new FormControl(null),
      primaryContactFamilyName: new FormControl(null),
      primaryContactEmail: new FormControl('', [Validators.required, Validators.email]),
      selectInvite: new FormControl(0)
    });
    this.initOrganisationContactForm();
    this.contactDetailsForm = new FormGroup({
      firstName: new FormControl('', [Validators.required]),
      familyName: new FormControl('', [Validators.required]),
      companyName: new FormControl(''),
    });
    this.userDetailsForm = new FormGroup({
      firstName: new FormControl('', [Validators.required]),
      familyName: new FormControl('', [Validators.required])
    });

    const oi: FormControl[] = [];
    this.organisationProperties.forEach((p, i) => {
      oi[i] = new FormControl(null);
    });

    const ai: FormControl[] = [];
    this.organisationAttributes.forEach((p, i) => {
      ai[i] = new FormControl(null);
    });
    this.contactOrganisationPropertiesForm = new FormGroup({
      organisationInputs: new FormArray(oi),
      organisationCheckboxes: new FormArray(ai)
    });
    this.onChanges();
  }

  initOrganisationContactForm(): void {
    this.organisationContactForm = new FormGroup({
      contactFirstName: new FormControl(null),
      contactFamilyName: new FormControl(null),
      contactEmail: new FormControl('', [Validators.required, Validators.email]),
      selectInvite: new FormControl(0),
    });
  }

  initServices(): void {
    this.isLoading = true;
    this.contactTypes = [];
    this.allOrganisations = [];
    // get contact types
    this.contactTypeSub = this.contactTypeService.getContactTypes().subscribe(type => {
      type.data.forEach(t => {
        this.contactTypes.push({label: t.name, value: t.id.toString()});
      });
      this.contactOrgSub = this.contactOrganisationsService.getContactOrganisations().subscribe(data => {
        if(data) {
          data.data.forEach(d => {
            this.allOrganisations.push({label: d.value, value: d.id.toString()});
          });
          // load forms
          this.initForms();
          this.setFormData();
          this.isLoading = false;
        }
      });
    });
  }

  setFormData() {
    console.dir(this.existingContact);
    if (this.existingContact) {
      this.stepTitles = this.stepTitlesEdit;
      this.emails = [];
      this.phones = [];
      const contact_type = {label: this.existingContact.contact_type.name, value: this.existingContact.contact_type.id.toString()};
      this.stepOneForm?.get('contactType')?.setValue(contact_type);
      if(this.existingContact.member_of) {
        const member_of = {label: this.existingContact.member_of.user_name, value: this.existingContact.member_of.id.toString()};
        this.stepOneForm?.get('memberOf')?.setValue(member_of);
      }
      this.stepOneForm?.get('roleType')?.setValue({label: this.existingContact.role_type, value: this.existingContact.role_type});
      this.stepOneForm?.get('isLegalRep')?.setValue(this.existingContact.legal_representative);
      this.stepOneForm?.get('isEntity')?.setValue(this.existingContact.is_organisation);
      if (this.existingContact.is_organisation > 0) {
        this.isOrganisation = true;
      }
      if (this.existingContact.primary_contact) {
        const primaryContact: GenericPair = {
          id: this.existingContact.primary_contact.id,
          value: this.existingContact.primary_contact.user_name
        };
        this.organisationDetailsForm?.get('memberOfExistingA')?.setValue(primaryContact);
      }
      this.existingContact.profile_properties.forEach(pp => {
        switch (pp.type) {
          case 'first_name':
            this.contactDetailsForm?.get('firstName')?.setValue(pp.value);
            break;
          case 'last_name':
            this.contactDetailsForm?.get('familyName')?.setValue(pp.value);
            break;
          case 'legal_name':
            this.organisationDetailsForm?.get('legalName')?.setValue(pp.value);
            break;
          case 'name':
            if (this.isOrganisation) {
              this.organisationDetailsForm?.get('organisationName')?.setValue(pp.value);
            }
            break;
          case 'email':
            this.emails.push({
              id: pp.id,
              type: pp.subtype ?? 'work',
              value: pp.value,
              default: pp.default_for_type === 1
            });
            break;
          case 'phone':
            this.phones.push({
              id: pp.id,
              type: pp.subtype ?? 'work',
              value: pp.value,
              default: pp.default_for_type === 1
            });
            break;
        }
      });
      const organisationInputsArray = this.contactOrganisationPropertiesForm?.get('organisationInputs') as FormArray;
      const organisationCheckboxesArray = this.contactOrganisationPropertiesForm?.get('organisationCheckboxes') as FormArray;
      this.existingContact.organisation_properties.forEach(op => {
        this.organisationProperties.forEach((p, i) => {
          if (p === op.label) {
            organisationInputsArray.at(i).setValue(op.value);
          }
        });
        this.organisationAttributes.forEach((p, i) => {
          if (p === op.label) {
            organisationCheckboxesArray.at(i).setValue(op.value);
          }
        });
      });
    }
  }

  onChanges(): void {
    if (this.stepOneForm) {
      this.stepOneForm?.get('isEntity')?.valueChanges.subscribe(val => {
        this.isOrganisation = val;
        if(this.isOrganisation) {
            this.contactOrganisationsService.getPossibleMembers().subscribe(d => {
                if(d) {
                    this.members = d.data;
                }
            });
        }
      });
      this.stepOneForm?.get('memberOf')?.valueChanges.subscribe(val => {
          if (val && val.value !== '0') {
            this.isOrganisation = false;
            this.stepOneForm?.get('isEntity')?.setValue(false);
            this.contactDetailsForm?.get('companyName')?.setValue(val.label);
            this.contactDetailsForm?.get('companyName')?.disable();
            this.stepThreeForm?.get('companyName')?.setValue(val.label);
            this.stepThreeForm?.get('companyName')?.disable();
          } else {
            this.contactDetailsForm?.get('companyName')?.setValue('');
            this.contactDetailsForm?.get('companyName')?.enable();
          }
        });
      this.stepOneForm?.get('selectInvite')?.valueChanges.subscribe(val => {
        console.dir(val);
          this.contactInvitation = val;
          if (!this.contactInvitation) {
            this.stepOneForm?.get('emailInvite')?.setValue(null);
          }
        });
    }
    if (this.organisationDetailsForm) {
      this.organisationDetailsForm?.get('addPrimaryContact')?.valueChanges.subscribe(val => {
        this.addPrimaryContact = val && val.length > 0;
      });
      this.organisationDetailsForm?.get('primaryContactEmail')?.valueChanges.subscribe(val => {
        this.invitePrimaryContact = this.organisationDetailsForm?.get('primaryContactEmail')?.valid ?? false;
      });
    }
    if (this.contactOrganisationPropertiesForm) {
      // organisationCheckboxes
      this.contactOrganisationPropertiesForm?.get('organisationInputs')?.valueChanges.subscribe(val => {
      });
      this.contactOrganisationPropertiesForm?.get('organisationCheckboxes')?.valueChanges.subscribe(val => {
      });
    }
  }

  // PARCELLING
  // ==========
  collectFormData(): void {
    this.collectNames();
    const isLegalRep = this.stepOneForm?.get('isLegalRep')?.value;
    this.collectContacts();
    const orgProps = this.collectOrganisationProperties();
    const profileProps = this.collectProfileProperties();
    const invitation = this.stepOneForm?.get('selectInvite')?.value ? 1 : 0;
    const invitation_email = this.stepOneForm?.get('emailInvite')?.value ?? '';
    const preferredContact = this.organisationDetailsForm?.get('memberOfExisting')?.value ?? 0;
    const preferredContactExisting = this.organisationDetailsForm?.get('memberOfExistingA')?.value ?? 0;
    let memberOf = this.stepOneForm?.get('memberOf')?.value;
    if (memberOf.value === '0') {
      memberOf = null;
    }
    this.gatheredData = {
      user_id: this.user_id,
      contact_type: this.stepOneForm?.get('contactType')?.value?.value ?? 0,
      role_type: this.stepOneForm?.get('roleType')?.value?.value ?? ContactRoleType.External,
      first_name: this.contactNames.first_name,
      last_name: this.contactNames.last_name,
      name:  this.isOrganisation ? this.organisationDetailsForm?.get('organisationName')?.value : '',
      legal_representative: isLegalRep ? 1 : 0,
      legal_name: this.organisationDetailsForm?.get('legalName')?.value ?? '',
      preferred_contact: preferredContactExisting ? preferredContactExisting.id : preferredContact.id ?? 0,
      is_organisation: this.isOrganisation ? 1 : 0,
      member_of: memberOf ? parseInt(memberOf.value) : 0,
      invitation: invitation,
      invitation_email:invitation_email,
      contacts: this.organisationContacts,
      organisation_properties: orgProps,
      profile_properties: profileProps
    };
  }

  collectNames(): void {
    const ufn = this.userDetailsForm?.get('firstName')?.value ?? null;
    const uln = this.userDetailsForm?.get('familyName')?.value ?? null;
    const cfn = this.contactDetailsForm?.get('firstName')?.value ?? null;
    const cln = this.contactDetailsForm?.get('familyName')?.value ?? null;
    const oco = this.organisationDetailsForm?.get('organisationName')?.value ?? null;
    const oln = this.organisationDetailsForm?.get('legalName')?.value ?? null;
    const cco = this.contactDetailsForm?.get('companyName')?.value ?? null;
    if(ufn || uln) {
      this.contactNames.first_name = ufn;
      this.contactNames.last_name = ufn;
    } else {
      this.contactNames.first_name = cfn;
      this.contactNames.last_name = cln;
    }
    this.contactNames.legal_name = oln;
    this.contactNames.name = this.isOrganisation && oco ? oco : cco;
  }

  collectContacts(): void {
    const pcfn = this.organisationDetailsForm?.get('primaryContactFirstName')?.value;
    const pcln = this.organisationDetailsForm?.get('primaryContactFamilyName')?.value;
    const pcem = this.organisationDetailsForm?.get('primaryContactEmail')?.value;
    const pcin = this.organisationDetailsForm?.get('selectInvite')?.value?.length > 0 ? 1 : 0;
    if(pcfn || pcln || pcem ) {
      const profileProperties: UserProfileProperty[] = [];
      if(pcfn) {
        profileProperties.push({
          id: 0,
          label: 'First name',
          isDefault: true,
          type: 'first_name',
          value: pcfn,
          default_for_type: 1
        });
      }
      if(pcln) {
        profileProperties.push({
          id: 0,
          label: 'Last name',
          isDefault: true,
          type: 'last_name',
          value: pcln,
          default_for_type: 1
        });
      }
      if(pcem) {
        profileProperties.push({
          id: 0,
          label: 'Email',
          isDefault: true,
          type: 'email',
          value: pcem,
          default_for_type: 1
        });
      }
      this.organisationContacts.unshift({
        first_name: pcfn,
        last_name: pcln,
        email: pcem,
        invitation: pcin,
        profile_properties: profileProperties
      })
    }
  }

  collectOrganisationProperties(): UserProfileProperty[] {
    const organisationProperties = this.contactOrganisationPropertiesForm?.get('organisationInputs')?.value;
    const organisationAttributes = this.contactOrganisationPropertiesForm?.get('organisationCheckboxes')?.value;
    const final: UserProfileProperty[] = [];
    if (organisationProperties.length > 0) {
      organisationProperties.forEach((property: any, i: number) => {
        if (property && property.length > 0) {
          const organisationProperty: UserProfileProperty = {
            id: 0,
            label: this.organisationProperties[i],
            isDefault: true,
            type: this.organisationProperties[i],
            value: property,
            default_for_type: 1
          };
          final.push(organisationProperty);
        }
      });
    }

    if (organisationAttributes.length > 0) {
      organisationAttributes.forEach((property: any, i: number) => {
        if (property) {
          const organisationProperty: UserProfileProperty = {
            id: 0,
            label: this.organisationAttributes[i],
            isDefault: true,
            type: this.organisationAttributes[i],
            value: property,
            default_for_type: 1
          };
          final.push(organisationProperty);
        }
      });
    }
    return final;
  }

  collectProfileProperties(): UserProfileProperty[] {
    const final: UserProfileProperty[] = [];
    // first and last name
    if (this.contactNames.first_name) {
      const fn: UserProfileProperty = {
        id: 0,
        label: 'First name',
        isDefault: true,
        type: 'first_name',
        value: this.contactNames.first_name,
        default_for_type: 1
      };
      final.push(fn);
    }
    if (this.contactNames.last_name) {
      const ln: UserProfileProperty = {
        id: 0,
        label: 'Last name',
        isDefault: true,
        type: 'last_name',
        value: this.contactNames.last_name,
        default_for_type: 1
      };
      final.push(ln);
    }
    if (this.contactNames.name && this.isOrganisation) {
      const n: UserProfileProperty = {
        id: 0,
        label: 'Name',
        isDefault: true,
        type: 'name',
        value: this.contactNames.name,
        default_for_type: 1
      };
      final.push(n);
    }
    if (this.contactNames.legal_name) {
      const leg: UserProfileProperty = {
        id: 0,
        label: 'Legal name',
        isDefault: true,
        type: 'legal_name',
        value: this.contactNames.legal_name,
        default_for_type: 1
      };
      final.push(leg);
    }
    // emails
    this.emails.forEach((email, i) => {
      const e: UserProfileProperty = {
        id: 0,
        label: 'Email',
        isDefault: email.default,
        type: 'email',
        subtype: email.type ?? 'work',
        value: email.value,
        default_for_type: email.default ? 1 : 0
      };
      final.push(e);
    });
    // phone numbers
    this.phones.forEach((phone, i) => {
      const p: UserProfileProperty = {
        id: 0,
        label: 'Phone',
        isDefault: phone.default,
        type: 'phone',
        subtype: phone.type ?? 'work',
        value: phone.value,
        default_for_type: phone.default ? 1 : 0
      };
      final.push(p);
    });
    return final;
  }

  submitForm(): void {
    this.stepNumber = 7;
    this.collectFormData();
    console.dir(this.gatheredData);
    if(this.gatheredData) {
      if(this.existingContact) {
        this.contactSetterService.addContactAlt(this.gatheredData, this.existingContact.id.toString()).subscribe(contact => {
          console.dir(contact)
          this.stepNumber = 8;
        })
      } else {

        this.contactSetterService.addContactAlt(this.gatheredData).subscribe(contact => {
          console.dir(contact)
          this.stepNumber = 8;
        })
      }
    }
  }

  onCancel(): void {
    this.initForms();
    this.stepNumber = 1;
    this.submit.emit(true);
  }

  onDone(): void {
    this.initForms();
    this.submit.emit(true);
  }

  // Steps
  // =====
  step(step: any, next?: any): void {
    let setPrevious = true;
    switch (step) {
      case 1: // start
          this.afterStepOne();
          break;
      case 2: // organisation details
          this.organisationName = this.organisationDetailsForm?.get('organisationName')?.value;
          this.afterOrganisationDetails();
          if (next && next === 3) {
            this.stepNumber = 3;
          } else {
            //send form
            this.submitForm();
          }
          break;
      case 3: // organisation secondary contacts
          if (next) {
            // repeat contact
            this.anotherOrganisationContact();
          } else {
            // send form
            this.submitForm();
          }
          break;
      case 4: // user details
          break;
      case 5: // general contact details
          this.afterContactDetails();
          break;
      case 6: // contacts org props
          this.submitForm();
          break;
      default:
          setPrevious = false;
          break;
    }
    if (setPrevious) {
      this.previousStepNumbers.push(+step);
    }
  }

  backStep(): void {
    this.stepNumber = this.previousStepNumbers.pop() ?? 1;
  }

  afterStepOne(): void {
    // const isEntity = this.stepOneForm?.get('isEntity')?.value;
    const selectInvite = this.stepOneForm?.get('selectInvite')?.value;
    let emailInviteStatus: boolean = false;
    const contactType = this.stepOneForm?.get('contactType')?.value;
    const invitation = this.stepOneForm?.get('selectInvite')?.value ? 1 : 0;
    const invitation_email = this.stepOneForm?.get('emailInvite')?.value ?? '';
    if (invitation_email && invitation === 1) {
      this.userCoreService.searchUserByEmail(invitation_email).subscribe(d => {
        console.dir(d);
        if(d) {
          // the ID object is incorrectly labelled in UserProfile
          // It states userId, but the response has id
          // @ts-ignore
          this.user_id = d.id;
          emailInviteStatus = !!(this.user_id) ?? false;
          console.log(this.user_id);
        }
      });
      this.emails.push({
        type: 'work',
        value: invitation_email,
        default: true
      });
    }
    if (!contactType) {
      this.messageService.clear();
      this.messageService.add({
        key: 'addContact',
        severity: 'error',
        summary: 'Error',
        detail: 'Please select a contact type.'
      });
      return;
    }
    if (invitation && !invitation_email) {
      this.messageService.clear();
      this.messageService.add({
        key: 'addContact',
        severity: 'error',
        summary: 'Error',
        detail: 'Please enter an email address for the invitation.'
      });
      return;
    }
    if (this.isOrganisation) {
      // contact is an organisation
      this.stepNumber = 2;
    } else if (selectInvite === true && emailInviteStatus) {
      // contact is a user
      this.messageService.clear();
      this.messageService.add({
        key: 'addContact',
        severity: 'info',
        summary: 'Good news!',
        detail: 'This contact is already in our system.'
      });
      this.stepNumber = 5;
    } else {
      // contact is generic
      // const memberOf = this.stepOneForm?.get('memberOf')?.value;
      // const companyName = memberOf?.label ?? '';
      // this.contactDetailsForm?.get('companyName')?.setValue(companyName);
      this.stepNumber = 5;
    }
  }

  afterOrganisationDetails(): void {
    const firstName = this.organisationDetailsForm?.get('primaryContactFirstName')?.value;
    const familyName = this.organisationDetailsForm?.get('primaryContactFamilyName')?.value;
    // const email = this.organisationDetailsForm?.get('primaryContactEmail')?.value;
    const existing = this.organisationDetailsForm?.get('memberOfExisting')?.value;
    const existingA = this.organisationDetailsForm?.get('memberOfExistingA')?.value;
    const hasSufficiency = (firstName && familyName);
    if(existing && hasSufficiency) {
      this.messageService.clear();
      this.messageService.add({
        key: 'addContact',
        severity: 'error',
        summary: 'Error',
        detail: 'Please choose either an existing contact or a new contact, not both.'
      });
      return;
    }
    if (!existingA && !existing && (!familyName || !firstName)) {
      this.messageService.clear();
      this.messageService.add({
        key: 'addContact',
        severity: 'error',
        summary: 'Error',
        detail: 'Please enter a name for this contact.'
      });
      return;
    }
    this.stepNumber = 6;
  }

  afterContactDetails(): void {
    const firstName = this.contactDetailsForm?.get('firstName')?.value;
    const familyName = this.contactDetailsForm?.get('familyName')?.value;
    if (!familyName || !firstName) {
      this.messageService.clear();
      this.messageService.add({
        key: 'addContact',
        severity: 'error',
        summary: 'Error',
        detail: 'Please enter a name for this contact.'
      });
      return;
    }
    this.stepNumber = 6;
  }

  anotherOrganisationContact(): void {
    const cfn = this.organisationContactForm?.get('contactFirstName')?.value;
    const cln = this.organisationContactForm?.get('contactFamilyName')?.value;
    const contact: ContactSimple = {
      first_name: cfn,
      last_name: cln,
      email: this.organisationContactForm?.get('contactEmail')?.value,
      invitation: this.organisationContactForm?.get('selectInvite')?.value,
      profile_properties: [
        {
          id: 0,
          label: 'First name',
          isDefault: true,
          type: 'first_name',
          value: cfn,
          default_for_type: 1
        },
        {
          id: 0,
          label: 'Last name',
          isDefault: true,
          type: 'last_name',
          value: cln,
          default_for_type: 1
        }
      ]

    }
    this.organisationContacts.push(contact);
    this.initOrganisationContactForm();
    this.stepNumber = 3;
  }

  // user invitations and checks
  // ===========================
  public userExist(email: string): Observable<boolean> {
    return this.userCoreService.userExists(email);
  }

  invite() {
    this.userExist(this.addContactForm?.value.contact_email_input.email_input).subscribe(data => {
          if (data) {
            this.stepNumber = 4;

          } else {
            this.stepNumber = 5;
          }
        }, error => {
          this.messageService.clear();
          this.messageService.add({
            key: 'addContact',
            severity: 'error',
            summary: 'Error',
            detail: error.error.title
          });
        }
    );
  }

  // TRIGGERS
  // ========

  // organisation details
  legalSame(): void {
    const name = this.organisationDetailsForm?.get('organisationName')?.value;
    this.organisationDetailsForm?.get('legalName')?.setValue(name);
  }

  // general contacts
  deleteDetail(type: string, index: number): void {
    if ( type === 'email') {
      this.emails.splice(index, 1);
    } else if ( type === 'phone') {
      this.phones.splice(index, 1);
    }
  }

  editDetail(type: string, details: ContactMethods): void {
    if (type === 'email') {
      this.editEmail = details;
      this.displayAddEmailModal = true;
    } else if (type === 'phone') {
      this.editPhone = details;
      this.displayAddPhoneModal = true;
    }
  }

  openAddEmail(): void {
    this.editEmail = null;
    this.displayAddEmailModal = true;
  }

  openAddPhone(): void {
    this.editPhone = null;
    this.displayAddPhoneModal = true;
  }

  makeDefaultDetail(type: string, index: number): void {
    if ( type === 'email') {
      const newerEmails: ContactMethods[] = [];
      this.emails.map((e, i) => {
        let newer: ContactMethods = {
          type: e.type,
          value: e.value,
          default: i === index
        };
        newerEmails.push(newer);
      });
      this.emails = newerEmails;
    } else if ( type === 'phone') {
      const newerPhones: ContactMethods[] = [];
      this.phones.map((e, i) => {
        let newer: ContactMethods = {
          type: e.type,
          value: e.value,
          default: i === index
        };
        newerPhones.push(newer);
      });
      this.phones = newerPhones;
    }
  }

  handleDetailClose(value: any): void {
    if (value === false) {
      this.editEmail = null;
      this.editPhone = null;
      this.displayAddEmailModal = false;
      this.displayAddPhoneModal = false;
    }
  }

  handleAdd(details: any): void {
    const values = details.value;
    const parcel: ContactMethods = {
      id: values.id,
      type: values.type.value,
      value: values.detail,
      default: values.isDefault !== 0
    };
    if (!values.id && values.detailType) {
      if (values.detailType === 'email') {
        this.emails.push(parcel);

      } else if (values.detailType === 'phone') {
        this.phones.push(parcel);

      }
    } else if (values.id && values.detailType) {
      // find the details to change
      if (values.detailType === 'email') {
        this.emails.forEach((e, i) => {
          if(e.id && e.id === values.id) {
            this.emails[i] = parcel;
          }
        });
      }
    }
    this.editEmail = null;
    this.editPhone = null;
    this.displayAddEmailModal = false;
    this.displayAddPhoneModal = false;
  }

} // end of component class
